import React, { useEffect, useMemo, useRef, useState } from "react";
import { ContentContainer } from "../../../components/layout";
import * as XLSX from "xlsx";
import {
  Button,
  DateRangePicker,
  DownloadButton,
  LoadingComponent,
  Modal,
  MultiSelectTable,
  Select,
  Table,
} from "../../../components/core";
import { CSVLink } from "react-csv";
import { useLazyQuery, useQuery } from "@apollo/client";
import { offsetLimitPagination } from "@apollo/client/utilities";
import {
  CLEAN_CLAIM_PACKAGES,
  GET_LOCKERS_BY_ID_FOR_LOCKER_CLEAN_UP,
  LOCKERS_FOR_LOCKER_CLEAN_UP,
  SUPPORT_STATIONS,
} from "../../../constants/graphql/locker-clean-up-queries";
import SendPulloutCode from "./modals/send-pullout-code-modal";
import { API } from "../../../constants/api";
import axios from "axios";
import { useSelector } from "react-redux";
import TotalRecords from "../../../components/core/total-records";
import PrimereactDateRange from "../../../components/core/date-range-primereact";
import {
  formatDate,
  formatDateTime,
  formatDateYYYYMMDD,
} from "../../../algorithms/date";
import { LOCKER_INFO } from "../../../constants/graphql/locker-queries";
import { QUERY_LOCKER_TYPE } from "../../../constants/graphql/drop-off-graphql";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Card } from "primereact/card";
import { InputSwitch } from "primereact/inputswitch";
import { paginatorTemplate } from "../settings-coins/components/paginatorTemplate";
import { Strings } from "../../../constants/strings";
import MobileLockerCards from "./components/mobile-cards";
import { packageStates } from "../view-package-history/pages/package-history-page";
function removeEmptyFields(obj) {
  for (const key in obj) {
    if (
      obj[key] === "" ||
      obj[key] === null ||
      obj[key] === undefined ||
      obj[key] === "-1" ||
      obj[key] === -1
    ) {
      delete obj[key];
    }
  }
}

// function formatDate(inputDate) {
//   const options = { year: "numeric", month: "short", day: "numeric" };
//   const date = new Date(inputDate);
//   return date.toLocaleDateString("en-US", options);
// }

function formatNumbers(mobileNumber) {
  if (mobileNumber)
    if (mobileNumber.length > 2) return mobileNumber.toString().substring(2);
  return mobileNumber;
}

export default function LockerCleanUp() {
  const accessPermission = useSelector(
    (state) => state.accessPermissions.accessPermissions,
  );
  const pullOutApi = `${process.env.REACT_APP_website_api}${API.pullout_api}`;
  //Local States
  const [searchResultSentence, setSearchResultSentence] =
    React.useState("Search result for");
  const [lockerCleanupData, setLockerCleanupData] = React.useState([]);
  const [rowClick, setRowClick] = useState(true);
  const [selectedRows, setSelectedRows] = useState([]);

  const [lockerList, setLockerList] = React.useState([]);
  const today = new Date();
  const threeMonthsFromNow = new Date();
  threeMonthsFromNow.setMonth(today.getMonth() - 3);
  const [searchCriteria, handleSearchCritera] = React.useState({
    operatorId: localStorage.getItem("user")
      ? JSON.parse(localStorage.getItem("user")).operator_id
      : "",
    lockerId: "-1",
    packageStateNo: "-1",
    startDate: threeMonthsFromNow,
    endDate: new Date(),
    lockerTypeId: "-1",
  });
  const [validation, setValidation] = React.useState({
    icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
    title: "",
    message: "",
    open: false,
  });

  const [openPulloutCode, setOpenPulloutCode] = React.useState(false);
  const [sending, setIsSending] = useState(false);

  const [selectedContact, setSelectedContact] = React.useState();
  const [valueChanged, setValueChanged] = useState(false);
  const [isSearched, setIsSearched] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedSupportStationId, setSelectedSupportStationId] =
    React.useState();
  const [supportStationData, setSupportStationData] = React.useState([]);
  //GQL
  const [claimCleanPackages, { data, loading }] = useLazyQuery(
    CLEAN_CLAIM_PACKAGES,
    { fetchPolicy: "no-cache" },
  );
  const lockers = useQuery(LOCKERS_FOR_LOCKER_CLEAN_UP, {
    variables: {
      operatorId: localStorage.getItem("user")
        ? JSON.parse(localStorage.getItem("user")).operator_id
        : "",
    },
  });

  const [lockerInfo, { data: lockerInfoData }] = useLazyQuery(LOCKER_INFO, {
    variables: {
      operatorId: localStorage.getItem("user")
        ? JSON.parse(localStorage.getItem("user")).operator_id
        : "",
    },
  });
  const fetchLockerType = useQuery(QUERY_LOCKER_TYPE);

  const lockersById = useQuery(GET_LOCKERS_BY_ID_FOR_LOCKER_CLEAN_UP, {
    variables: {
      operatorId: localStorage.getItem("user")
        ? JSON.parse(localStorage.getItem("user")).operator_id
        : "",
      lockerId: searchCriteria.lockerId,
    },
  });
  const [supportStations] = useLazyQuery(SUPPORT_STATIONS, {
    variables: { supportStationId: selectedSupportStationId },
  });

  //   memo
  const lockerTypeList = useMemo(() => {
    if (fetchLockerType.data) {
      return fetchLockerType.data.lockerTypes.map((lockerType) => ({
        value: lockerType.lockerTypeId,
        name: lockerType.lockerType,
      }));
    }
  }, [fetchLockerType.data]);

  useEffect(() => {
    if (searchCriteria.lockerTypeId !== "-1") {
      lockerInfo({
        variables: {
          operatorId: localStorage.getItem("user")
            ? JSON.parse(localStorage.getItem("user")).operator_id
            : "",
          lockerTypeId: searchCriteria.lockerTypeId,
        },
      })
        .then((response) => {
          if (response?.data?.lockerInfo) {
            const lockers = response.data.lockerInfo.map((locker) => ({
              value: locker.lockerId,
              name: locker.lockerName,
              contacts: locker.contacts || [],
              contactsCount: locker.contacts?.length || 0,
            }));
            setLockerList(lockers);
          }
        })
        .catch((error) => {
          console.error("Error fetching locker info:", error);
          setLockerList([]);
        });
    } else {
      setLockerList([]);
    }
  }, [searchCriteria.lockerTypeId]);

  console.log({ lockerList });

  console.log({ searchCriteria });
  // Functions
  const downloadExcel = () => {
    const ws = XLSX.utils.table_to_sheet(
      document.getElementById("cleanup-table"),
    );
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    XLSX.writeFile(wb, `${"cleanup-report"}.xlsx`);
  };

  console.log({ lockerCleanupData, selectedRows });
  const sendSms = (lockerId, newRecipientMobile) => {
    let newData = [];
    selectedRows.forEach((element) => {
      newData.push({
        package_id: element.packageId,
        old_recipient_mobile: `63${element.recipientMobile}`,
      });
    });

    console.log({ newData });
    let payload = {
      operator_id: Number(
        localStorage.getItem("user")
          ? JSON.parse(localStorage.getItem("user")).operator_id
          : "",
      ),
      locker_id: Number(lockerId),
      packages: newData,
      new_recipient_mobile: newRecipientMobile,
    };
    axios.post(pullOutApi, payload).then((response) => {
      try {
        console.log(response);
        response.data.d === 1
          ? setValidation({
              icon: `${process.env.PUBLIC_URL}/assets/images/check.png`,
              title: "Success",
              message: "PULLOUT CODES SENT.",
              open: true,
              actions: (
                <div className="w-full">
                  <Button
                    onClick={() => {
                      setValidation({ open: false });

                      setIsSending(false);
                      setSelectedContact();
                      window.location.reload();
                    }}
                    value={"OK"}
                    className={"p-2 w-full"}
                  />
                </div>
              ),
            })
          : setValidation({
              icon: `${process.env.PUBLIC_URL}/assets/images/check.png`,
              title: "Error",
              message: "An error occurred when sending the email!",
              open: true,
              actions: (
                <div className="w-full">
                  <Button
                    onClick={() => {
                      setValidation({ open: false });

                      setIsSending(false);
                    }}
                    value={"OK"}
                    className={"p-2 w-full"}
                  />
                </div>
              ),
            });
      } catch (error) {
        console.log(error);
        setValidation({
          icon: `${process.env.PUBLIC_URL}/assets/images/check.png`,
          title: "Error",
          message: error.text,
          open: true,
          actions: (
            <div className="w-full">
              <Button
                onClick={() => setValidation({ open: false })}
                value={"OK"}
                className={"p-2 w-full"}
              />
            </div>
          ),
        });
      }
    });
  };

  useEffect(() => {
    if (loading) {
      setIsLoading(true);
    } else {
      setIsLoading(false);
    }
  }, [loading]);

  // Handle Changes
  const handleSearchLockerCleanUpData = () => {
    // if (searchCriteria.lockerTypeId === "-1") {
    //   setValidation({
    //     icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
    //     title: "Incomplete Search Criteria",
    //     message: Strings.popup_error_message_search_criteria,
    //     open: true,
    //     actions: (
    //       <div className="w-full">
    //         <Button
    //           onClick={() => setValidation({ open: false })}
    //           value={"OK"}
    //           className={"p-2 w-full"}
    //         />
    //       </div>
    //     ),
    //   });
    // } else

    if (
      searchCriteria.lockerTypeId !== "-1" &&
      searchCriteria.lockerId === "-1"
    ) {
      setValidation({
        icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
        title: "Incomplete Search Criteria",
        message: Strings.popup_error_message_search_criteria,
        open: true,
        actions: (
          <div className="w-full">
            <Button
              onClick={() => setValidation({ open: false })}
              value={"OK"}
              className={"p-2 w-full"}
            />
          </div>
        ),
      });
    } else {
      const start = formatDateYYYYMMDD(searchCriteria.startDate);
      const end = formatDateYYYYMMDD(searchCriteria.endDate);

      let searchCriteriaTemp = { ...searchCriteria };
      searchCriteriaTemp.startDate = start;
      searchCriteriaTemp.endDate = end;

      removeEmptyFields(searchCriteriaTemp);
      claimCleanPackages({ variables: searchCriteriaTemp })
        .then((response) => {
          if (response.data) {
            setIsSearched(true);
          }
        })
        .catch((e) => {
          console.log(e);
        });
      setSearchResultSentence(
        `Search result for${" "} Locker ${
          lockerList.find((x) => x.value === searchCriteriaTemp.lockerId)
            ? lockerList.find((x) => x.value === searchCriteriaTemp.lockerId)
                .name
            : "ALL Lockers"
        } ${" "} ${
          searchCriteriaTemp.packageStateNo
            ? packageStates[searchCriteria.packageStateNo]
            : "ALL Package States"
        } From ${formatDate(searchCriteriaTemp.startDate)} to ${formatDate(
          searchCriteriaTemp.endDate,
        )}`,
      );
      lockersById.refetch({
        operatorId: localStorage.getItem("user")
          ? JSON.parse(localStorage.getItem("user")).operator_id
          : "",
        lockerId: searchCriteria.lockerId,
      });
      // supportStations({
      // 	variables: { supportStationId: selectedSupportStationId },
      // }).then((data) => {
      // 	if (data.data) {
      // 		let tempData = [];
      // 		if (data.data.supportStation.mobile != null) {
      // 			tempData.push({
      // 				value: data.data.supportStation.mobile,
      // 				name: `${data.data.supportStation.mobile} (${data.data.supportStation.supervisor})`,
      // 			});
      // 		}
      // 		if (data.data.supportStation.mobile2.supervisor2 != null) {
      // 			tempData.push({
      // 				value: data.data.supportStation.mobile2,
      // 				name: `${data.data.supportStation.mobile2} (${data.data.supportStation.supervisor2})`,
      // 			});
      // 		}
      // 		setSupportStationData(tempData);
      // 	}
      // });
    }
  };

  const handleChangeSearchCriteria = (event) => {
    const { name, value } = event.target;

    setIsSearched(false);
    setLockerCleanupData([]);
    setSelectedRows([]);

    if (name === "lockerId") {
      if (value !== "-1") {
        setSelectedSupportStationId(
          lockerList.find((x) => x.value === value).supportStationId,
        );
      }
    }

    // Reset dependent fields when parent changes
    if (name === "lockerTypeId") {
      // When locker type changes, reset locker selection
      handleSearchCritera((prev) => ({
        ...prev,
        [name]: value,
        lockerId: "-1",
      }));
    } else {
      // For other fields, just update normally
      handleSearchCritera((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };
  const handleSendPulloutCode = (lockerId, newRecipientMobile) => {
    setOpenPulloutCode(false);
    setIsSending(true);
    console.log({ LOCKER_ID_RECEIVED: lockerId });
    sendSms(lockerId, newRecipientMobile);
  };

  const convertToCSV = (data) => {
    const headers =
      "Courier Number, Recipient Number, Package Date, Waybill, Package State, Locker Location, Contact Person, Contact Number, Date Executed";

    const body = data
      .map((row) => {
        console.log({ row });
        const courierNumber = row.partnerAgentMobile;
        const recipientNumber = row.recipientMobile;
        const packageDate = row.packageDate;
        const waybillNo = row.waybillNumber;
        const packageState = row.packageStateNo;
        const lockerName = row.lockerLocation;

        return `${courierNumber}, ${recipientNumber}, ${packageDate}, ${waybillNo}, ${packageState}, ${lockerName}`;
      })
      .join("\n");
    return `${headers}\n${body}`;
  };

  const exportCSV = () => {
    const csvData = convertToCSV(
      lockerCleanupData.length > 0 ? lockerCleanupData : [],
    );

    console.log({ csvData });
    const blob = new Blob([csvData], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;

    a.download = "Locker Cleanup Report.csv";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };
  // USe Effects
  React.useEffect(() => {
    if (data) {
      let tempArr = [];
      data.cleanClaimPackages.forEach((element) => {
        if (
          element.packageStateNo === 130 ||
          element.packageStateNo === 140 ||
          element.packageStateNo === 141
        ) {
          tempArr.push({
            packageId: element.packageId,
            statusDate: formatDate(element.statusDate),
            partnerAgentMobile: formatNumbers(element.partnerAgentMobile),
            recipientMobile: formatNumbers(element.recipientMobile),
            packageDate: element.packageDate,
            pickupByDate: element.pickupDate,
            waybillNumber: element.waybillNumber,
            packageStateNo: packageStates[element.packageStateNo],
            lockerLocation: element.lockerLocation,
          });
        }
      });

      setLockerCleanupData(tempArr);
    }
  }, [data]);
  //   React.useEffect(() => {
  //     if (lockers.data) {
  //       let tempList = [];
  //       lockers.data.lockers.forEach((element) => {
  //         tempList.push({
  //           value: element.lockerId,
  //           name: element.lockerName,
  //           supportStationId: element.supportStationId,
  //         });
  //       });
  //       setLockerList(tempList);
  //     }
  //   }, [lockers.data]);

  const dt = useRef(null);
  const dt2 = useRef(null);

  return (
    <ContentContainer containerTitle={"Locker Clean Up"}>
      <div className="grid grid-cols-5 gap-2 mb-2 h-full pb-10">
        <div className="col-span-5">
          <div className="grid grid-cols-10 items-center space-y-3">
            <div className="font-bold col-span-10 pt-3">Locker:</div>
            <>
              <div className="col-span-3 md:col-span-2">
                <p className="">Locker Type:</p>
              </div>
              <div className="md:col-span-4 col-span-6">
                <Select
                  name="lockerTypeId"
                  items={lockerTypeList}
                  defaultOption={{
                    value: "-1",
                    name: "-- All --",
                  }}
                  onChange={handleChangeSearchCriteria}
                />
              </div>
            </>

            <div className="col-span-1 md:col-span-4 "></div>

            <>
              <div className="col-span-3 md:col-span-2">
                <p className="">Locker:</p>
              </div>
              <div className="md:col-span-4 col-span-6">
                <Select
                  disabled={searchCriteria.lockerTypeId === "-1"}
                  name="lockerId"
                  items={lockerList}
                  defaultOption={{
                    value: "-1",
                    name: "-- All --",
                  }}
                  onChange={handleChangeSearchCriteria}
                />
              </div>
            </>

            <div className="col-span-1 md:col-span-4 "></div>

            <div className="font-bold col-span-10 pt-3">Package:</div>

            <>
              <div className="col-span-3 md:col-span-2">
                <p className="">Package State:</p>
              </div>
              <div className="md:col-span-4 col-span-6">
                <Select
                  name="packageStateNo"
                  items={[
                    { value: "140", name: "For Pull-Out" },
                    { value: "130", name: "For Take-Back" },
                    { value: "141", name: "RTS Overstay" },
                  ]}
                  defaultOption={{ value: "-1", name: "-- All --" }}
                  onChange={handleChangeSearchCriteria}
                />
              </div>
            </>

            <div className="col-span-1 md:col-span-4 "></div>
            <div className="font-bold col-span-10 pt-3">Date Filter:</div>

            <>
              <PrimereactDateRange
                className={"col-span-9 md:col-span-4"}
                onChange={handleChangeSearchCriteria}
                startDateName="startDate"
                endDateName="endDate"
                startDate={searchCriteria.startDate}
                endDate={searchCriteria.endDate}
                readOnlyInput={true}
                max={new Date()} // Today's date as the maximum
                min={new Date("2021-01-01")} // Jan 1, 2021, as the minimum
              />
            </>

            <div className="col-span-10"></div>

            <>
              <Button
                className={"p-2 md:col-span-2 col-span-3"}
                value="Search"
                disabled={isLoading}
                onClick={handleSearchLockerCleanUpData}
              />
            </>
          </div>
        </div>
      </div>

      {loading && <LoadingComponent />}

      {/* implement datatable selectionMode */}
      {isSearched && !loading && data && (
        <>
          <Card className="hidden md:grid">
            <div className="flex w-full justify-between bg-primary-primaryYellow items-center pl-3 h-[40px]">
              <TotalRecords count={lockerCleanupData.length} />
              <DownloadButton
                dt={dt2}
                csvOnly={true}
                className="mb-2"
                value="Download CSV"
                specialCase={true}
                onClick={exportCSV}
              />
            </div>
            <DataTable
              selectionMode={
                rowClick
                  ? null
                  : searchCriteria.lockerId === "-1"
                    ? null
                    : "checkbox"
              }
              value={lockerCleanupData}
              stripedRows
              rows={10}
              ref={dt2}
              removableSort
              sortMode="multiple"
              selection={searchCriteria.lockerId === "-1" ? null : selectedRows}
              onSelectionChange={
                searchCriteria.lockerId === "-1"
                  ? null
                  : (e) => setSelectedRows(e.value)
              }
              paginator
              exportFilename="Locker Clean Up Report"
              paginatorTemplate={paginatorTemplate}
            >
              <Column
                selectionMode="multiple"
                headerStyle={{ width: "3rem" }}
                className={`${
                  isSearched && searchCriteria.lockerId !== "-1" ? "" : "hidden"
                } bg-slate-200`}
                headerClassName={`${
                  isSearched && searchCriteria.lockerId !== "-1" ? "" : "hidden"
                } bg-primary-primaryYellow`}
              ></Column>
              <Column
                field="lockerLocation"
                header="Locker Name"
                sortable
                headerClassName="bg-primary-primaryYellow"
              />
              <Column
                field="partnerAgentMobile"
                header="Courier Mobile Number"
                headerClassName="bg-primary-primaryYellow"
              />
              <Column
                field="recipientMobile"
                header="Recipient Mobile Number"
                headerClassName="bg-primary-primaryYellow"
              />
              <Column
                field="waybillNumber"
                header="Waybill"
                headerClassName="bg-primary-primaryYellow"
              />
              <Column
                field="packageDate"
                header="Package Date"
                sortable
                headerClassName="bg-primary-primaryYellow"
                body={(rowData) => formatDateTime(rowData.packageDate)}
              />
              <Column
                field="packageStateNo"
                header="Package State"
                sortable
                headerClassName="bg-primary-primaryYellow"
              />
            </DataTable>

            <div className="w-full flex justify-centers">
              {searchCriteria.lockerId && searchCriteria.lockerId !== "-1" && (
                <Button
                  disabled={
                    accessPermission.lockerCleanUp === 1 ||
                    accessPermission.lockerCleanUp === "1" ||
                    selectedRows.length === 0
                  }
                  value={"SEND PULLOUT CODE TO MAINTENANCE"}
                  className={"p-2 mx-auto my-4"}
                  onClick={() => setOpenPulloutCode(true)}
                />
              )}
            </div>
          </Card>

          <MobileLockerCards
            lockerCleanupData={lockerCleanupData}
            selectedRows={selectedRows}
            setSelectedRows={setSelectedRows}
            searchCriteria={searchCriteria}
            setOpenPulloutCode={setOpenPulloutCode}
            accessPermission={accessPermission}
          />
        </>
      )}

      <SendPulloutCode
        open={openPulloutCode}
        sending={sending}
        setIsSending={setIsSending}
        onClose={() => {
          setOpenPulloutCode(false);
          setSelectedContact("-1");
          // setSelectedRows([]);
        }}
        selectedContact={selectedContact}
        setSelectedContact={setSelectedContact}
        onSendPulloutCode={(params) =>
          handleSendPulloutCode(params.lockerId, params.newRecipientMobile)
        }
        lockerData={lockerList.find(
          (x) => parseInt(x.value) === parseInt(searchCriteria.lockerId),
        )}
        // lockerData={lockersById.data ? lockersById.data.lockers[0] : {}}
        supportStationId={selectedSupportStationId}
        supportStationData={supportStationData}
        totalSelectedPackages={selectedRows.length}
      />
      <Modal
        icon={validation.icon}
        title={validation.title}
        message={validation.message}
        open={validation.open}
        actions={validation.actions}
      />
    </ContentContainer>
  );
}
